export let hres82eColumns = () => {
  let indexColumns = [{
    key: 'roomno',
    name: '',
    labelCodapp: 'HRES82EC1',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_roomno',
    name: '',
    labelCodapp: 'HRES82EC1',
    labelIndex: '40',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_staappr',
    name: '',
    labelCodapp: 'HRES82EC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 60px;'
  }, {
    key: 'timperiod',
    name: '',
    labelCodapp: 'HRES82EC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRES82EC1',
    labelIndex: '70',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_codcomp',
    name: '',
    labelCodapp: 'HRES82EC1',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }]

  let detailColumns = [{
    key: 'dtereq',
    name: '',
    labelCodapp: 'HRES82EC2',
    labelIndex: '130',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRES82EC2',
    labelIndex: '140',
    style: 'min-width: 150px;'
  }, {
    key: 'timperiod',
    name: '',
    labelCodapp: 'HRES82EC2',
    labelIndex: '150',
    class: 'align-center',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_staappr',
    name: '',
    labelCodapp: 'HRES82EC2',
    labelIndex: '160',
    style: 'min-width: 60px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRES82EC2',
    labelIndex: '170',
    style: 'min-width: 150px;'
  }]

  return {
    en: {
      index: indexColumns,
      detail: detailColumns
    },
    th: {
      index: indexColumns,
      detail: detailColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres82e.js